/**
 * Enregistrement du service worker de L22 (`src/sw/index.ts`, construit en `/sw.js` par `vite.config.ts`).
 * Rien n'est enregistré hors production : en développement, un service worker servirait une coquille périmée.
 * Un échec d'enregistrement ne doit jamais empêcher l'application de démarrer (on reste en ligne, sans cache).
 */
export interface NavigateurPwa {
  serviceWorker?: { register: (url: string, options?: { scope: string }) => Promise<ServiceWorkerRegistration> };
}

export interface OptionsEnregistrement {
  readonly production?: boolean;
  readonly navigateur?: NavigateurPwa;
}

export const URL_SERVICE_WORKER = '/sw.js';

const enProduction = (): boolean => (import.meta as ImportMeta & { env?: { PROD?: boolean } }).env?.PROD === true;

export async function enregistrerServiceWorker(options: OptionsEnregistrement = {}): Promise<ServiceWorkerRegistration | null> {
  const { production = enProduction(), navigateur = typeof navigator === 'undefined' ? {} : navigator } = options;
  if (!production || !navigateur.serviceWorker) return null;
  try {
    return await navigateur.serviceWorker.register(URL_SERVICE_WORKER, { scope: '/' });
  } catch {
    return null;
  }
}
